export const email_geral = "agendaskupien@gmail.com";